import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { loadGarage } from './garageData';

const GarageContext = createContext(null);

const INITIAL_STATE = { loading: true, vehicles: [], error: null };

// Carrega veiculos e historico uma vez para toda a area do cliente (abas, garagem e historico).
export function GarageProvider({ children }) {
  const [state, setState] = useState(INITIAL_STATE);

  const reload = useCallback(async () => {
    setState((previous) => ({ ...previous, loading: true }));
    const result = await loadGarage();
    setState({ loading: false, vehicles: result.vehicles, error: result.error });
  }, []);

  useEffect(() => {
    let active = true;
    loadGarage().then((result) => {
      if (active) setState({ loading: false, vehicles: result.vehicles, error: result.error });
    });
    return () => { active = false; };
  }, []);

  const pendingEvaluations = state.vehicles.reduce((sum, v) => sum + v.pendingEvaluations, 0);
  const partial = state.vehicles.some((v) => v.failed);

  return (
    <GarageContext.Provider value={{ ...state, pendingEvaluations, partial, reload }}>
      {children}
    </GarageContext.Provider>
  );
}

export function useGarage() {
  const value = useContext(GarageContext);
  if (!value) throw new Error('useGarage precisa estar dentro de <GarageProvider>');
  return value;
}
